<template>
  <div class="image-container" :style="{ '--align': resizeAlign }">
    <img :src="questionData.url" class="img" />
  </div>
</template>
<script>
export default {
  props: {
    questionData: {
      type: Object,
    },
  },
  computed: {
    resizeAlign() {
      if (this.questionData.align === 'right') {
        return 'flex-end';
      }
      if (this.questionData.align === 'left') {
        return 'flex-start';
      }
      return 'center';
    },
  },
};
</script>
<style lang="scss" scoped>
.image-container {
  display: flex;
  justify-content: var(--align);
  width: 100%;
}

.img {
  max-width: 100%;
  height: auto;
}
</style>
